/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from "react";

export default (WrappedComponent) =>
  ({ ...restProps }) => {
    useEffect(() => {
      if (window) {
        window.scroll(0, 0);
      }
    }, []);

    return <WrappedComponent {...restProps} />;
  };
